export const LanguageCodes = [
  'en-GB', 'en-US', 'de-DE', 'de-CH', 'de-AT', 'ar', 'bn',
  'zh', 'cs', 'da', 'nl', 'fi', 'fr', 'hi', 'hu', 'it', 'ja',
  'ko', 'lv', 'nb-NO', 'pl', 'pt', 'ro', 'ru', 'sr', 'sk', 'es', 'sv',
  'tr', 'vi'
]
